import { useMutation, useQuery } from "@tanstack/react-query";
import { baseApi } from "./baseApi";

export const usePostRevokeBrokerKeys = () => {
  return useMutation({
    mutationKey: ["revoke-broker-key"],
    mutationFn: async ({ userId, key }: { userId?: string; key: string }) => {
      const response = await baseApi.post(
        `/reset_broker_configuration?user_id=${userId}&broker_id=${key}`,
      );
      return response;
    },
  });
};

export const usePostSubmitBrokerKeys = () => {
  return useMutation({
    mutationKey: ["submit-broker-key"],
    mutationFn: async ({
      userId,
      key,
      brokerId,
      passphrase,
      secret,
    }: {
      userId?: string;
      key: string;
      brokerId: string;
      passphrase: string;
      secret: string;
    }) => {
      const response = await baseApi.post(
        `/save_broker_api_keys?user_id=${userId}&key=${key}&broker_id=${brokerId}&secret=${secret}&passphrase=${passphrase}`,
      );
      return response;
    },
  });
};

export const useGetCtraderAccounts = () => {
  return useMutation({
    mutationKey: ["get_ctrader_accounts"],
    mutationFn: async ({ access_token }: { access_token?: string }) => {
      const response = await baseApi.get(
        `/get_ctrader_accounts?access_token=${access_token}`,
      );
      return response;
    },
  });
};

export const useGetFennelAccounts = () => {
  return useMutation({
    mutationKey: ["get_fennel_accounts"],
    mutationFn: async ({ access_token }: { access_token?: string }) => {
      const response = await baseApi.get(
        `/get_fennel_accounts?access_token=${access_token}`,
      );
      return response;
    },
  });
};

export const useGetBrokerLogin = () => {
  return useMutation({
    mutationKey: ["social_login"],
    mutationFn: async ({
      token,
      broker,
    }: {
      token?: string;
      broker?: string;
    }) => {
      const response = await baseApi.get(
        `/social_login?token=${token}&broker=${broker}`,
      );
      return response;
    },
  });
};
export const useGetPublicUrl = () => {
  return useMutation({
    mutationKey: ["public_connection_url"],
    mutationFn: async ({ user_id }: { user_id?: string }) => {
      const response = await baseApi.get(
        `/public_connection_url?user_id=${user_id}`,
      );
      return response;
    },
  });
};

export const useGetBrokerDeatils = () => {
  return useMutation({
    mutationKey: ["get_leverate_brokers"],
    mutationFn: async () => {
      const response = await baseApi.get(`/get_leverate_brokers`);
      return response;
    },
  });
};

export const useGetConnectTradeAccounts = ({
  accounts_uuid,
  broker_id,
  user_id,
}: {
  accounts_uuid?: string;
  broker_id?: string;
  user_id?: string;
}) => {
  return useQuery({
    queryKey: ["connecttrade-accounts", accounts_uuid],
    queryFn: async () => {
      const response = await baseApi.get(
        `/accounts/connecttrade?accounts_uuid=${accounts_uuid}&broker_id=${broker_id}&user_id=${user_id}`,
      );
      return response?.data;
    },
    enabled: !!accounts_uuid,
  });
};

export const usePostSelectConnectTradeAccount = () => {
  return useMutation({
    mutationKey: ["select_connecttrade_account"],
    mutationFn: async ({
      user_id,
      broker_id,
      account_id,
      connection_id,
    }: {
      user_id?: string;
      broker_id?: string;
      account_id?: string;
      connection_id?: string;
    }) => {
      const response = await baseApi.post(
        `/choose-account/connecttrade?user_id=${user_id}&broker_id=${broker_id}&account_id=${account_id}&connection_id=${connection_id}`,
      );

      return response.data;
    },
  });
};

export const useGetBrokerOauthSterling = () => {
  return useMutation({
    mutationKey: ["select_connecttrade_account"],
    mutationFn: async ({
      user_id,
      username,
      password,
    }: {
      user_id?: string;
      username?: string;
      password?: string;
    }) => {
      const response = await baseApi.get(
        `/broker-oauth/sterling?user_id=${user_id}&username=${username}&password=${password}`,
      );

      return response.data;
    },
  });
};

export const useGetSterlingAccounts = ({
  token,
  broker_id,
  user_id,
}: {
  token?: string;
  broker_id?: string;
  user_id?: string;
}) => {
  return useQuery({
    queryKey: ["sterling-accounts", token],
    queryFn: async () => {
      const response = await baseApi.get(
        `/accounts/sterling?token=${token}&broker_id=${broker_id}&user_id=${user_id}`,
      );
      return response?.data;
    },
    enabled: !!token,
  });
};

export const usePostSelectSterlingAccount = () => {
  return useMutation({
    mutationKey: ["select_sterling_account"],
    mutationFn: async ({
      user_id,
      broker_id,
      account,
      token,
    }: {
      user_id?: string;
      broker_id?: string;
      account?: string;
      token?: string;
    }) => {
      const response = await baseApi.post(
        `/choose-account/sterling?user_id=${user_id}&broker_id=${broker_id}&account=${account}&token=${token}`,
      );

      return response.data;
    },
  });
};
